import React from 'react';
export function Header() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className="sticky top-0 w-full bg-navy z-40 border-b border-white/10 shadow-md" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between" data-id="element-116">
        <div className="flex items-center gap-3" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/h84MHAz1wLnhee739csdrA/_vd-yBYkVV4GGjDCpwrs2rQ_-ulCWs0OSo-cuA9KvxGbUQ_cover.png" alt="Código Calma Logo" className="h-10 md:h-12 object-contain" data-id="element-118" />
          <span className="text-white font-heading font-bold text-lg hidden sm:block tracking-tight" data-id="element-119">
            CÓDIGO CALMA
          </span>
        </div>
        <a href="#pricing" onClick={scrollToPricing} className="bg-orange hover:bg-orange-500 text-white font-semibold py-2 px-4 md:px-6 rounded-md transition-all transform hover:scale-105 text-sm md:text-base shadow-lg" data-id="element-120">
          Quiero el Acceso
        </a>
      </div>
    </header>;
}